/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PrivDoctypesApiFrom } from '../../models/priv-doctypes-api-from';

export interface ApiV3ServiceListPrivDoctypesGet$Plain$Params {

/**
 * Interface language
 */
  lang?: string;

/**
 * id perks
 */
  privId?: number;
}

export function apiV3ServiceListPrivDoctypesGet$Plain(http: HttpClient, rootUrl: string, params?: ApiV3ServiceListPrivDoctypesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PrivDoctypesApiFrom>>> {
  const rb = new RequestBuilder(rootUrl, apiV3ServiceListPrivDoctypesGet$Plain.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.query('privId', params.privId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PrivDoctypesApiFrom>>;
    })
  );
}

apiV3ServiceListPrivDoctypesGet$Plain.PATH = '/api/v3/service/ListPrivDoctypes';
